//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank';
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
     components: {
        cmBlank,cmLoadmore
    },
    data(){
        return {
            blankShow:false,
            pop:false,
            popUp:false,
            height:'100%',
            loadStatus:false,
            loadmoreText:'正在加载。。。',
            busy:false,
            list:[],
            where:[],
            hasNext:0,
            pageFlag:2,
            lastId:0,
            grade:0,
            money:0,
            amount:'',
            info:{
                community_balance:0
            },
            moneyMax:5000,
            isActive:1,
            types:[
                {
                    'key':0,
                    'text':'提现记录',
                },
                {
                    'key':1,
                    'text':'变动记录',
                },
            ],
        }
    },
    mounted(){
        this.getInfo();
    },
    methods: {
        getInfo(){
            this.$api.getInfo({}).then((res)=>{
                if(res){
                    this.info = res.data;
                }
            })
        },
         select(i){
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.hasNext = 0;
            this.list = [];
            this.loadmore();
        },
        getList(){
            switch(parseInt(this.isActive)){
                case 1:
                     this.$api.balanceList({last_id:this.lastId,page_flag:this.pageFlag}).then((res)=>{
                        if(res){
                            if(!this.lastId){
                                this.blankShow = res.data.length > 0 ? false : true;
                            }
                            this.hasNext = res.hasNext;
                            this.lastId = res.lastId;
                            res.data.forEach((item)=>{
                                this.list.push(item);
                            });
                        }
                    });
                break;
                default:
                    this.$api.withdrawRecord({last_id:this.lastId,page_flag:this.pageFlag,type:1}).then((res)=>{
                        if(res){
                            if(!this.lastId){
                                this.blankShow = res.data.length > 0 ? false : true;
                            }
                            this.hasNext = res.hasNext;
                            this.lastId = res.lastId;
                            res.data.forEach((item)=>{
                                this.list.push(item);
                            });
                        }
                    });
                break;
            }
        },
        openPop(){
            this.pop = true;
            this.popUp = true;
        },
        closePop(){
            this.pop = false;
            this.popUp = false;
        },
        recharge(){
            if(this.amount <= 0){
                this.$func.showToast('请输入充值金额');
                return false;
            }
            if (typeof WeixinJSBridge == "undefined"){
                if( document.addEventListener ){
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                }else if (document.attachEvent){
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                }
            }else{
                this.onBridgeReady();
            }
            },
        onBridgeReady(){
            let that = this;
            this.$api.recharge({money:this.amount}).then((res)=>{
                if(res){
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', res.data,
                        function(res){
                            if(res.err_msg == "get_brand_wcpay_request:ok" ){
                                that.$func.showToast('支付成功');
                                setTimeout(()=>{
                                    that.$router.push({name:'balance'})
                                },300);
                            }else{
                                that.$func.showToast('已取消支付');
                            }
                            that.closePop();
                        }
                    ); 
                }
            })
        },
        withdraw() {
            if(this.info.withdraw <= 0){
                this.$func.showToast('无可提现金额');
                return false;
            }
            this.$router.push({path: '/withdraw', query: {ids:'',type:1}});
        },
         loadmore(){
            if(this.lastId > 0 && !this.hasNext){
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。'
                return ;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(()=>{
            if(this.blankShow){
                    this.busy = true;
                    this.loadStatus = false;
                    this.loadmoreText = '没有更多了。。。'
                }else{
                    if(this.hasNext > 0){
                        this.loadStatus = false;
                        this.busy = false;
                    }else{
                        this.busy = true;
                        this.loadStatus = true;
                        this.loadmoreText = '没有更多了。。。'
                    }
                }
            },1500)
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/balance.vue